const ASSINATURA_ESTAGIO = {
  RG: {
    id: 'RG',
    descricao: 'Registrado',
    icon: 'flag',
    color: 'secondary',
    iconColor: 'textSecondary',
    iconSize: 20,
    valor: 0,
    actLabel: 'Registrar'
  },
  CN: {
    id: 'CN',
    descricao: 'Conferido',
    icon: 'check',
    color: 'warn',
    iconColor: 'warn',
    iconSize: 20,
    valor: 3,
    actLabel: 'Conferir'
  },
  VR: {
    id: 'VR',
    descricao: 'Verificado',
    icon: 'double_check',
    color: 'info',
    iconColor: 'info',
    iconSize: 20,
    valor: 5,
    actLabel: 'Verificar'
  },
  AP: {
    id: 'AP',
    descricao: 'Aprovado',
    icon: 'stamp',
    color: 'success',
    iconColor: 'primaryLight',
    iconSize: 20,
    valor: 7,
    actLabel: 'Aprovar'
  }
};

export default ASSINATURA_ESTAGIO;
